import React from 'react';
import { getToken } from '../services/tokenService';
import { Badge } from './ui/badge';

export const SPACES = [
  { value: 'default', label: 'Par défaut', sub: 'Admin · Partenaire · Bénéficiaire', badge: 'bg-slate-700 text-white border-slate-700', dot: 'bg-slate-300' },
  { value: 'member',  label: 'Membre',     sub: 'Adhérents particuliers',           badge: 'bg-blue-700 text-white border-blue-700',     dot: 'bg-blue-300' },
  { value: 'cooper',  label: "COOPER'S",   sub: 'Coopérateurs terrain',             badge: 'bg-teal-700 text-white border-teal-700',     dot: 'bg-teal-300' },
  { value: 'expert',  label: 'Expert',     sub: "Production d'expertises",          badge: 'bg-rose-700 text-white border-rose-700',     dot: 'bg-rose-300' },
];

export const SPACE_META = Object.fromEntries(SPACES.map((s) => [s.value, s]));

export const FONTS = {
  playfair: { fontFamily: '"Playfair Display", Georgia, serif' },
  outfit: { fontFamily: '"Outfit", system-ui, sans-serif' },
  body: { fontFamily: '"IBM Plex Sans", system-ui, sans-serif' },
};

export const emptyConfig = () => ({
  header: { title: '', subtitle: '', color_from: '#0a1e3f', color_to: '#0B3C5D' },
  free_actions: [],
  categories: [],
  how_it_works: [],
  credit_types: [],
});

export const apiUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;
export const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  'Content-Type': 'application/json',
});

export const SectionHeader = ({ icon: Icon, title, subtitle, action }) => (
  <div className="flex items-center justify-between gap-4 pb-3 mb-4 border-b border-slate-100">
    <div className="flex items-center gap-3 min-w-0">
      {Icon && (
        <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#0a1e3f] flex items-center justify-center">
          <Icon className="h-4 w-4 text-[#fbbf24]" />
        </div>
      )}
      <div className="min-w-0">
        <h3 className="text-base font-semibold text-slate-900" style={FONTS.outfit}>{title}</h3>
        {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
    </div>
    {action}
  </div>
);

export const Card = ({ children, className = '' }) => (
  <div className={`bg-white border border-slate-200 rounded-xl shadow-sm ${className}`}>{children}</div>
);

export const SpaceBadge = ({ space }) => {
  const meta = SPACE_META[space];
  if (!meta) return null;
  return (
    <Badge variant="outline" className={`${meta.badge} text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5`}>
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dot} mr-1.5`} />
      {meta.label}
    </Badge>
  );
};
